import { connect } from 'react-redux';
import ExportPopUp from '../../components/sections/ExportPopUp.js';
import { createExportConfigurationObject } from '../../helpers/tools.js';

const mapStateToProps = state => {
  return { exportData: createExportConfigurationObject(state) };
};
const mapDispatchToProps = () => {
  return {};
};

const ExportPopUpRedux = connect(mapStateToProps, mapDispatchToProps)(ExportPopUp);

export default ExportPopUpRedux;
